import { SelectItem } from 'primeng/api';

export const yesNoOptions: SelectItem[] = [
    { label: 'Oui', value: true },
    { label: 'Non', value: false }
];

